// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__utJYa","link":"Tab_link__pDRlI","link_active":"Tab_link_active__R+BaN","disabled":"Tab_disabled__slbyf","product":"Tab_product__5oR1q"};